module.exports = __webpack_public_path__ + "static/media/31.57d8e100.jpeg";